import React, { useEffect, useState } from 'react'
import { Formik, Form } from 'formik'
import { Button, Autocomplete, TextField } from '@mui/material'
import * as Yup from 'yup'
import {
  ApiGetAdminList,
  ApiGetClientEntities,
  ApiPutUpdateEditors,
  ApiPutUpdateTrainers
} from '../../../apiService/Core/Apicall.tsx'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

interface ViewEditorsBusinessProps {
  onSubmit: (values: any) => void
}

interface Editor {
  label: string
  value: string
}

interface Business {
  label: string
  value: string
}

const ViewEditorsBusiness: React.FC<ViewEditorsBusinessProps> = ({
  onSubmit
}) => {
  const [businesses, setBusinesses] = useState<Business[]>([])
  const [editors, setEditors] = useState<Editor[]>([])
  const [trainers, setTrainers] = useState<Editor[]>([])
  const location = useLocation()
  const navigate = useNavigate()
  const { id } = useParams()
  // const store = location?.state?.store
  const [store, setStore] = useState<any>([])
  //const [editorIds, setEditorIds] = useState(store?.editorIds || [])

  const [editorIds, setEditorIds] = useState([])
  const [trainingIds, setTrainingIds] = useState([])

  useEffect(() => {
    const handleGetEditType = async () => {
      try {
        const response: any = await ApiGetAdminList('')
        const transformedData = response.data.map((item: any) => ({
          value: item.userId,
          label: item.displayName
        }))
        setEditors(transformedData)
        setTrainers(transformedData)
      } catch (error) {
        console.error('Error during API call:', error)
      }
    }

    handleGetEditType()
    handleGetClientList()
  }, [])



  const handleGetClientList = async () => {
    const data = `?clientEntityId=${id}`
    try {
      const response: any = await ApiGetClientEntities(data)
      if (response?.status) {
        setStore(response?.data[0])

        const editors = response?.data[0]?.editorIds?.split(',').map(id => parseInt(id.trim(), 10))
        const trainers = response?.data[0]?.trainerIds?.split(',').map(id => parseInt(id.trim(), 10))
        setEditorIds(editors)
        setTrainingIds(trainers)
      }
    } catch (error) {
      console.error('Error during API call:', error)
    }
  }

  const validationSchema = Yup.object({
    business: Yup.string().required('Please select a business'),
    editors: Yup.array()
      .of(Yup.string())
      .min(1, 'At least one editor must be selected')
  })
  const validationSchema1 = Yup.object({
    business: Yup.string().required('Please select a business'),
    trainers: Yup.array()
      .of(Yup.string())
      .min(1, 'At least one trainer must be selected')
  })

  const handleSubmit = async (values: any) => {
    // Convert the selected editors (array) to a comma-separated string only when submitting
    const commaSeparated = values.editors.length > 0 ? values.editors.join(',') : ''

    console.log('Editor IDs (comma separated):', commaSeparated)

    const data = {
      clientEntityId: values.business,
      editorIds: commaSeparated, // Send as a comma-separated string for the API
      createdBy: Number(localStorage.getItem('createdBy')),
      modifiedBy: Number(localStorage.getItem('createdBy')),
    }

    try {
      const res = await ApiPutUpdateEditors(data)
      toast.success('View Editors updated successfully!')
      navigate(-1)
    } catch (error) {
      console.error('Error during API call:', error)
    }
  }

  const handleSubmit1 = async (values: any) => {
    const commaSeparated = values.trainers.length > 0 ? values.trainers.join(',') : ''

    const data = {
      clientEntityId: values.business,
      trainerIds: commaSeparated,
      modifiedBy: Number(localStorage.getItem('createdBy')),
    }

    try {
      const res = await ApiPutUpdateTrainers(data)
      toast.success('View Trainers updated successfully!')
      navigate(-1)
    } catch (error) {
      console.error('Error during API call:', error)
    }
  }


  return (
    <>
      <Formik
        enableReinitialize
        initialValues={{
          business: id,
          editors: editorIds
        }}

        validationSchema={validationSchema}
        onSubmit={values => {
          handleSubmit(values)
        }}
      >
        {({ values, setFieldValue, errors, touched }) => (
          <Form style={{ background: 'white', padding: '30px' }}>
            <h1 className='common-add'>View Editors for Business</h1>

            {/* Business Selector */}
            <div className='form-group'>
              <TextField value={store?.entityName} disabled fullWidth></TextField>
              {/* <Autocomplete
              options={businesses}
              value={
                businesses.find(option => option.value === values.business) ||
                null
              }
              getOptionLabel={option => option.label}
              onChange={(event, newValue) => {
                setFieldValue('business', newValue ? newValue.value : '')
              }}
              disabled
              renderInput={params => (
                <TextField
                  {...params}
                  label='Select Business'
                  fullWidth
                  error={touched.business && Boolean(errors.business)}
                  helperText={touched.business && errors.business}
                />
              )}
            /> */}
            </div>

            {/* Editors Multi-Select */}
            <div className='form-group' style={{ marginTop: '20px' }}>
              <Autocomplete
                multiple
                options={editors}
                getOptionLabel={option => option.label}
                value={editors.filter((editor: any) =>
                  values?.editors?.map(Number)?.includes(Number(editor?.value))
                )}
                onChange={(event, value) => {
                  const selectedValues = value.map(editor => editor.value)
                  setFieldValue('editors', selectedValues) // Update editors array
                }}
                renderInput={params => (
                  <TextField
                    {...params}
                    label='Editors'
                    fullWidth
                    error={touched.editors && Boolean(errors.editors)}
                    helperText={touched.editors && errors.editors}
                  />
                )}
              />
            </div>

            {/* Submit Button */}
            <div className='text-center' style={{ marginTop: '30px' }}>
              <Button
                style={{ padding: '9px 70px' }}
                type='submit'
                variant='contained'
                color='primary'
                className='table-row-background'
              >
                Submit
              </Button>
            </div>
          </Form>
        )}
      </Formik>
      <Formik
        enableReinitialize
        initialValues={{
          business: id,
          trainers: trainingIds
        }}
        validationSchema={validationSchema1}
        onSubmit={values => {
          handleSubmit1(values)
        }}
      >
        {({ values, setFieldValue, errors, touched }) => (
          <Form style={{ background: 'white', padding: '30px' }}>
            <h1 className='common-add'>View Trainers for Business</h1>

            <div className='form-group'>
              <TextField value={store?.entityName} disabled fullWidth></TextField>
            </div>

            <div className='form-group' style={{ marginTop: '20px' }}>
              <Autocomplete
                multiple
                options={trainers}
                getOptionLabel={option => option.label}
                value={trainers.filter((trainer: any) =>
                  values?.trainers?.map(Number).includes(trainer.value)
                )}
                onChange={(event, value) => {
                  const selectedValues = value.map(editor => editor.value)
                  setFieldValue('trainers', selectedValues)
                }}
                renderInput={params => (
                  <TextField
                    {...params}
                    label='Trainers'
                    fullWidth
                    error={touched.trainers && Boolean(errors.trainers)}
                    helperText={touched.trainers && errors.trainers}
                  />
                )}
              />
            </div>

            {/* Submit Button */}
            <div className='text-center' style={{ marginTop: '30px' }}>
              <Button
                style={{ padding: '9px 70px' }}
                type='submit'
                variant='contained'
                color='primary'
                className='table-row-background'
              >
                Submit
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  )
}

export default ViewEditorsBusiness
